// Permitir Localizacao
// Salvar Cliques
// Botão de Subir Rolagem

function splitByStyle(data, style = 1) {
    let result = [];
    let temp = [];

    for (let i = 0; i < data.length; i++) {
        if (data[i].style === style) {
            if (temp.length) {
                result.push(temp);
                temp = [];
            }
        }
        temp.push(data[i]);
    }

    if (temp.length) {
        result.push(temp);
    }

    return result;
}

const getSectionsContentNode = (sections = [], alreadySplited = false) => {
    if (sections[0].style == 1 && sections[1].style != 2) {
        sections[0].style = 2;
    } else if (sections[0].style == 1) {
        sections = sections.slice(1);
    }
    const splitedSections = alreadySplited ? sections : splitByStyle(sections, 2);
    return {
        type: 1,
        sections: splitedSections[0],
        child: splitedSections.length > 1 ? getSectionsContentNode(splitedSections.slice(1), true) : null
    }
}

const getHandoutsSectionsTree = (sections = []) => {
    return {
        type: 2,
        question: "Escolha o assunto que você deseja saber:",
        options: splitByStyle(sections.filter(s => s.style > 0), 1).map((splitedSections) => {
            return {
                title: splitedSections[0].text,
                child: getSectionsContentNode(splitedSections)
            }
        })
    }
}

export const handouts = (clinicalHandouts = []) => {
    const options = clinicalHandouts.map((handout) => {
        return {
            title: handout.name,
            subtitle: handout.content_type == 4 ? 'Doenças' : 'Medicamentos',
            id: handout.id,
            child: getHandoutsSectionsTree(handout.sections)
        }
    });
    return {
        "type": 1,
        "child": {
            "type": 2,
            "question": "Qual folheto você deseja visualizar?",
            "options": options
        },
        "sections": [
            {
                "style": 2,
                "text": "Obtenha informações importantes sobre os cuidados do seu pet."
            },
            {
                "style": 3,
                "text": "Seu médico veterinário compartilhou com você folhetos informativos sobre o tratamento do seu pet."
            },
            {
                "style": 3,
                "text": "Caso tenha alguma dúvida ou preocupação sobre a saúde do seu animal de estimação, entre em contato diretamente com seu veterinário."
            }
        ]
    }
}